export const renderEquipmentFieldFromJsonForm = (value) => {
	if (value && typeof value === 'string') {
		try {
			const valueParsed = JSON.parse(value);
			return valueParsed.id && valueParsed.code ?
				`${valueParsed.code} ${valueParsed.specification ? `(${valueParsed.specification})` : ''}`
				: 'N/A';
		} catch {
			return value;
		}
	}
	return value;
};

export const renderInformationFieldFromJsonForm = (value) => {
	if (value && typeof value === 'string') {
		try {
			const isAddress = value.includes('aa1');
			let isEquipment = false;
			let isSignature = false;

			if (typeof value === 'string' && value.includes('"id"')) {
				if (value.includes('"signedAt"')) {
					isSignature = true;
				} else {
					isEquipment = true;
				}
			}

			if (isAddress) {
				const addresses = value.match(/\{.*?\}/g) ?? [];
				if (addresses.length) {
					return addresses
						.map((_add) => {
							const addressParsed = JSON.parse(_add);
							return addressParsed.street
								? addressParsed.street
								: 'N/A';
						})
						.join('; ');
				}
				return 'N/A';
			} else if (isEquipment) {
				const equipments = value.match(/\{.*?\}/g) ?? [];
				if (equipments.length) {
					return equipments.map(renderEquipmentFieldFromJsonForm).join('; ');
				}
				return 'N/A';
			} else if (isSignature) {
				const signatures = value.match(/\{.*?\}/g) ?? [];
				const result = signatures
					.map((_sign) => {
						const parsed = JSON.parse(_sign);
						return parsed?.name
							? parsed.name
							: 'N/A';
					})
					.join('; ');

				return `Signed by: ${result ? result : 'N/A'}`;
			} else {
				return value;
			}
		} catch {
			return value;
		}
	}
	return value;
};
